// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","whiteFill":"_2ibyP","noFill":"x7Lhb","noStroke":"_3O1op"};